import './polyfills-safari';

import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import moment from 'moment';
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';
import packageJson from '../package.json';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { filterSentryEvent, IGNORED_ERROR_MESSAGES } from './app/shared/utils/sentry-filter';

if (environment.production) {
  Sentry.init({
    dsn: 'https://68b87c7e7382460c98962192dcd4f314@o103809.ingest.us.sentry.io/2517946',
    // Config Sentry : https://docs.sentry.io/platforms/javascript/guides/angular/configuration/
    release: 'ecni-front-angular@' + packageJson.version,
    environment: environment.env + '-' + environment.defaultLanguage,
    initialScope: {
      tags: {
        site: environment.site_name,
        locale: environment.defaultLanguage,
      },
    },
    ignoreErrors: IGNORED_ERROR_MESSAGES,
    beforeSend: filterSentryEvent,
    normalizeDepth: 5,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.extraErrorDataIntegration({ depth: 3, captureErrorCause: true }),
      Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] }),
      // Si besoin de profilage
      // Sentry.browserProfilingIntegration(),
      // Si erreur non reproductible
      // Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.05,
    // Si besoin de profilage
    // profilesSampleRate: 0.01,
  });
}

registerLocaleData(environment.localeData, environment.defaultLanguage);
registerLocaleData(environment.localeData, environment.locale);
moment.locale(environment.defaultLanguage);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
